/* src/app/modules/extractions/components/entity-viewer/entity-viewer.component.scss */
.nested-value {
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 1rem;
  padding: 0.2rem 0;
}
.nested-value .nested-key {
  min-width: 9rem;
  max-width: 9rem;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.nested-value .nested-value {
  word-break: break-word;
  overflow-wrap: anywhere;
}
/*# sourceMappingURL=entity-viewer.component.css.map */
